import Vue from 'vue'
import moment from 'moment'
import numeral from 'numeral'

Vue.filter('formatDate', date => {
  if (date == '---') {
    return '---'
  }
  date = ( typeof date === 'string' ) ? date.slice(0, 11) : ''
  const formatDate = (date + '00:00:00.000Z')
  if (!date) return
  return moment(formatDate).format('DD/MM/YYYY')
})

Vue.filter('formatNumber', number => {
  return numeral(number).format('0,0')
})

Vue.filter('formatDDMMYYYYHHMMSS', date => {
  if (date == '---') {
    return '---'
  }
  date = ( typeof date === 'string' ) ? date.slice(0, 11) : ''
  const formatDate = (date + '00:00:00.000Z')
  if (!date) return
  return moment(formatDate).format('DD/MM/YYYY HH:mm:ss')
})

Vue.filter('formatNumber', number => {
  return numeral(number).format('0,0')
})

Vue.filter('formatStatusDebt', (type) => {
    if (type === 'OPEN') return 'Chưa thanh toán'
    if (type === 'REPAYING') return 'Đúng hạn'
    if (type === 'MISREPAYMENT') return 'Trả góp đang trễ hạn'
    if (type === 'SETTLED') return 'Hoàn tất'
    if (type === 'OVERDUE') return 'Quá hạn'
})

Vue.filter('formatStatusOrder', (type) => {
  if (type === 'DRAFT') return 'Nháp'
  if (type === 'SUCCESS') return 'Thành công'
  if (type === 'FAIL') return 'Đã huỷ'
  if (type === 'PROCESSING') return 'Đang tiến hành'
  if (type === 'CANCELED') return 'Đã huỷ'
})
// DRAFT, PROCESSING, SUCCESS, CANCELED
Vue.filter('formatTypeDebt', (type) => {
  if (type === 'lending') return 'Khoản phải thu'
  if (type === 'borrowing') return 'Khoản phải trả'
})

Vue.filter('formatMoney', (val) => {
  let output = "";

  val = ( typeof val === 'number' ) ? val.toString().split(".").join("") : val

  while (val.length >= 3) {
    const last3Digits = val.slice(val.length - 3, val.length);
    val = val.slice(0, val.length - 3);
    output = "." + last3Digits + output;
  }
  if (val.length === 0) {
    output = output.slice(1, output.length);
  } else {
    output = val + output;
  }

  if (output.slice(0, 2) == '-.' ) {
    output = output.replace('-.', '- ')
  }
  return output + " đ";
})

Vue.filter('formatFormOfPayment', (val) => {
  if ( val === '{method:cash}') {
    return 'Tiền mặt'
  }
  if ( val === '{method:remittance}') {
    return 'Chuyển khoản'
  }
})

Vue.filter('formatStateEmployee', (val) => {
  if ( val === 'INACTIVE') {
    return 'Tạm khóa'
  }
  if ( val === 'ACTIVE') {
    return 'Hoạt dộng'
  }
})

Vue.filter('formatGender', (val) => {
  if ( val === 'MALE' ) {
    return 'Nam'
  }
  if ( val === 'FEMALE' ) {
    return 'Nữ'
  }
  if ( val === 'OTHER' ) {
    return 'Khác'
  }
  if ( val == '---' ) {
    return '---'
  }
})


Vue.filter('formatLocation', (val) => {
  if (val != '' && val != null) {
    const inforMerchant = JSON.parse(localStorage.getItem("auth.currentUser"))
    const locationMerchant = inforMerchant.locationInfos.map(e => e.id)
    const indexVal = locationMerchant.findIndex(e => e === val)
    const resul = (inforMerchant.locationInfos[indexVal]) ? inforMerchant.locationInfos[indexVal].name : '---'
    return resul
  } else {
    return val
  }
})

Vue.filter('formatLocationAddress', (val) => {
  if (val != '' && val != null) {
    const inforMerchant = JSON.parse(localStorage.getItem("auth.currentUser"))
    const locationMerchant = inforMerchant.locationInfos.map(e => e.id)
    const indexVal = locationMerchant.findIndex(e => e === val)
    const result = (inforMerchant.locationInfos[indexVal]) ? inforMerchant.locationInfos[indexVal].address.name : '---'
    return result
  } else {
    return val
  }
})

Vue.filter('formatCurrency', (val) => {
  return val.toLocaleString('de-DE', {style : 'currency', currency : 'VND'})
})

Vue.filter('SourceOrder', (type) => {
  if (type === 'NEXT_SHOP_POS_APP') return 'Nextshop App'
  if (type === 'NEXT_SHOP_POS_WEB' | type === 'NEXT_SHOP_POS_WEB_ENABLE_DRAFT') return 'Bạn tại cửa hàng'
  if (type === 'ONLINE_STORE') return 'Gian hàng trực tuyến'
})

Vue.filter('parsePaymetMethod', (type) => {
  if (type === 'CASH') return 'Tiền mặt'
  if (type === 'BANK') return 'Chuyển khoản'
  if (type === 'MPOS') return 'Mpos'
  if (type === 'OTHER') return 'Quẹt thẻ'
  if (type === 'DEBT_NOTE') return 'Ghi nợ'
  if (type === 'COD') return 'COD'
  if (type === 'PAYON') return 'Payon'
})

Vue.filter('mapArrStatusSync', (status) => {
  if (status === 'NOT_SENT') return 'Chưa đồng bộ'
  if (status === 'REQUEST_RECEIVED') return 'Đã tiếp nhận'
  if (status === 'PROCESSING') return 'Đang chuyển đổi'
  if (status === 'COMPLETED') return 'Hoàn tất'
  if (status === 'ERROR') return 'Lỗi'
})